import { render, staticRenderFns } from "./en-US.vue?vue&type=template&id=d12a759e&"
import script from "./en-US.vue?vue&type=script&lang=js&"
export * from "./en-US.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12a759e')) {
      api.createRecord('d12a759e', component.options)
    } else {
      api.reload('d12a759e', component.options)
    }
    module.hot.accept("./en-US.vue?vue&type=template&id=d12a759e&", function () {
      api.rerender('d12a759e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/en-US.vue"
export default component.exports